import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TpAudioEditorComponent } from './tp-audio-editor.component';
import { DragAndDropDirective } from './drag-and-drop.directive';
import { ModuleWithProviders } from '@angular/core/src/metadata/ng_module';
export class TpAudioEditorModule {
/**
 * @return {?}
 */
static forRoot(): ModuleWithProviders {
    return {
      ngModule: TpAudioEditorModule
    };
  }
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CommonModule,
    FormsModule
  ],
  declarations: [
    TpAudioEditorComponent,
    DragAndDropDirective,
  ],
  exports: [
    TpAudioEditorComponent
  ]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function TpAudioEditorModule_tsickle_Closure_declarations() {
/** @type {?} */
TpAudioEditorModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
TpAudioEditorModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
